<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @search-reset="searchClear"
        @row-update="handleUpdate"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot="searchMenu"></template>
        <template slot="search"></template>
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-printer"
            size="small"
            plain
            @click.stop="printJson()"
          >打印</el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="downloadExcelArDetail"
          >下载Excel</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="success"
            icon="el-icon-view"
            size="small"
            plain
            @click.stop="serviceListing(scope.row)"
          >查看采购明细</el-button>
        </template>
      </avue-crud>
      <el-dialog
        :visible.sync="reasonDialog"
        title="退回理由"
        center
        width="300px"
      >
        <div style="display: flex;">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入退回理由"
            v-model="returnReason"
          ></el-input>
        </div>
        <div class="typeButton">
          <el-button
            round
            size="mini"
            @click="reasonDialog = false"
          >&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button
            round
            type="danger"
            size="mini"
            @click="typeEditOk"
          >&nbsp;&nbsp;&nbsp;确定&nbsp;&nbsp;&nbsp;</el-button>
        </div>
      </el-dialog>
    </basic-container>
    <el-dialog
      :visible.sync="lookDialog"
      center
      width="1000px"
      v-if="isOpen"
    >
      <div class="stockwrap">
        <!--startprint-->
        <div
          v-bind="stockData"
          class="stockMain"
          id="printBox"
        >
          <h1
            class="stockMain title"
            id="printTitle"
            style="font-weight: Medium;color:#333;"
          >采购出库单</h1>
          <div
            v-if="isPrint"
            id="printTime"
          >
            <div>{{"打印时间："+handleFormatterDateToUTC(new Date().getTime()) }}</div>
            <div>{{this.companyName}}</div>
          </div>
          <div
            class="stockMain content"
            id="content"
          >
            <table
              border
              style="width:900px"
            >
              <tr>
                <th style="width:300px">采购入库单编号:</th>
                <th style="width:300px;">{{stockData.number}}</th>
                <th style="width:300px">采购商户名称:</th>
                <th style="width:300px">{{stockData.shopName}}</th>
              </tr>
              <tr>
                <th style="width:300px">法人姓名:</th>
                <th style="width:300px">{{stockData.name}}</th>
                <th style="width:300px">店铺地址:</th>
                <th style="width:300px">{{stockData.address}}</th>
              </tr>
              <tr>
                <th style="width:300px">采购时间:</th>
                <th style="width:300px">{{handleFormatterDateToUTC(stockData.createTime)}}</th>
                <th style="width:300px">商品数量共计:</th>
                <th style="width:300px">{{stockData.goodsAmount}}</th>
              </tr>
              <tr>
                <th style="width:300px">采购金额:</th>
                <th style="width:300px">{{stockData.price}}</th>
                <th style="width:300px">支付状态:</th>
                <th style="width:300px">{{stockData.payStatus == 'FINISH' ? '已支付' : '待支付'}}</th>
              </tr>
              <tr>
                <th style="width:300px">结算方式:</th>
                <th style="width:300px">{{stockData.payType == "INSTALLMENT"?"月结":"现款现货"}}</th>
                <th style="width:300px">订单状态:</th>
                <th style="width:300px">{{stockData.status == 'WAIT_PAY' ? '待付款' : (stockData.status == 'WAIT_OUT' ? '待出库' : (stockData.status == 'WAIT_CONFIRM' ? '待收货': (stockData.status == 'RETURNED' ? '已退回': (stockData.status == 'FINISH' ? '已完成': (stockData.status == 'INVALID' ? '已失效': (stockData.status == 'CANCELED' ? '已取消': ('StatusError:'+stockData.status)))))))}}</th>
              </tr>
              <tr v-if="stockData.status == 'WAIT_OUT'"></tr>
              <tr v-if="stockData.status == 'RETURNED'">
                <th
                  style="width:300px"
                  v-if="stockData.returnReason"
                >退回原因:</th>
                <th
                  style="width:300px"
                  v-if="stockData.returnReason"
                >{{stockData.returnReason}}</th>
                <th
                  style="width:300px"
                  v-if="stockData.returnTime"
                >退回时间:</th>
                <th
                  style="width:300px"
                  v-if="stockData.returnTime"
                >{{stockData.returnTime?handleFormatterDateToUTC(stockData.returnTime):stockData.returnTime}}</th>
              </tr>
              <tr v-if="stockData.status == 'WAIT_CONFIRM'">
                <th
                  style="width:300px"
                  v-if="stockData.removalTime"
                >出库时间:</th>
                <th
                  style="width:300px"
                  v-if="stockData.removalTime"
                >{{stockData.removalTime?handleFormatterDateToUTC(stockData.removalTime):stockData.removalTime}}</th>
                <th></th>
                <th></th>
              </tr>
              <tr v-if="stockData.status == 'WAIT_PAY'">
                <th
                  style="width:300px"
                  v-if="stockData.removalTime"
                >出库时间:</th>
                <th
                  style="width:300px"
                  v-if="stockData.removalTime"
                >{{stockData.removalTime?handleFormatterDateToUTC(stockData.removalTime):stockData.removalTime}}</th>
                <th
                  style="width:300px"
                  v-if="stockData.receiveTime"
                >收货时间:</th>
                <th
                  style="width:300px"
                  v-if="stockData.receiveTime"
                >{{stockData.receiveTime?handleFormatterDateToUTC(stockData.receiveTime):stockData.receiveTime}}</th>
              </tr>
              <tr v-if="stockData.status == 'FINISH'">
                <th
                  style="width:300px"
                  v-if="stockData.removalTime"
                >出库时间:</th>
                <th
                  style="width:300px"
                  v-if="stockData.removalTime"
                >{{stockData.removalTime?handleFormatterDateToUTC(stockData.removalTime):stockData.removalTime}}</th>
                <th
                  style="width:300px"
                  v-if="stockData.receiveTime"
                >收货时间:</th>
                <th
                  style="width:300px"
                  v-if="stockData.receiveTime"
                >{{stockData.receiveTime?handleFormatterDateToUTC(stockData.receiveTime):stockData.receiveTime}}</th>
              </tr>
              <tr v-if="stockData.status == 'FINISH'">
                <th
                  style="width:300px"
                  v-if="stockData.payTime"
                >支付时间:</th>
                <th
                  style="width:300px"
                  v-if="stockData.payTime"
                >{{stockData.payTime?handleFormatterDateToUTC(stockData.payTime):stockData.payTime}}</th>
                <th></th>
                <th></th>
              </tr>

              <tr>
                <th
                  style="width:300px"
                  v-if="stockData.cancelTime"
                >取消时间:</th>
                <th
                  style="width:300px"
                  v-if="stockData.cancelTime"
                >{{stockData.cancelTime?handleFormatterDateToUTC(stockData.cancelTime):stockData.cancelTime}}</th>
                <th
                  style="width:300px"
                  v-if="stockData.loseTime"
                >失效时间:</th>
                <th
                  style="width:300px"
                  v-if="stockData.loseTime"
                >{{stockData.loseTime?handleFormatterDateToUTC(stockData.loseTime):stockData.loseTime}}</th>
              </tr>
            </table>
            <avue-crud
              :option="table1Option"
              :data="table1Data"
              :table-loading="tableLoading"
              border
              ref="crud"
              style="width:auto;margin:0;margin-top:15px"
            ></avue-crud>
          </div>
          <div
            class="stockMain btn"
            id="noprint"
          >
            <!-- <el-button
              @click="doPdf"
              v-if="stockData.status !='CANCELED' && stockData.status !='INVALID'"
            >下载PDF</el-button>-->
            <el-button
              @click="doPrint"
              v-if="stockData.status !='CANCELED' && stockData.status !='INVALID'"
            >打印 / 另存为PDF</el-button>
            <el-button
              v-if="stockData.status == 'WAIT_OUT'"
              @click="reasonDialog = true"
            >退回</el-button>
            <el-button
              v-if="stockData.status == 'WAIT_OUT'"
              @click="handleDetailOut"
            >出库</el-button>
            <!-- <el-button
              v-if="stockData.status == 'WAIT_CONFIRM' || stockData.status == 'WAIT_PAY'"
              @click="toArDetail"
            >查看应收款</el-button>-->
          </div>
        </div>
        <!--endprint-->
        <!-- <el-dialog :visible.sync="reasonDialog" title="退回理由" center width="300px"> -->
        <!-- <div style="display: flex;">
            <el-input type="textarea" :rows="4" placeholder="请输入退回理由" v-model="returnReason"></el-input>
          </div>
          <div class="typeButton">
            <el-button
              round
              size="mini"
              @click="reasonDialog = false"
            >&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
            <el-button
              round
              type="danger"
              size="mini"
              @click="typeEditOk"
            >&nbsp;&nbsp;&nbsp;确定&nbsp;&nbsp;&nbsp;</el-button>
        </div>-->
        <!-- </el-dialog> -->
      </div>
    </el-dialog>
  </div>
</template>

    <script>
import { mapGetters } from "vuex";
import { arDetailOption } from "@/const/salesCloud/arDetailOption";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import {
  invoiceSystemV2ReceiverAgentDetail,
  invoiceSystemV2Purchase,
  invoiceSystemV2ReceiverAgentDetailDownload,
  downloadPDF,
  stockRemoval,
  stockRemovalReturn
} from "@/api/salesCloud/ar";
import { findUserInfo } from "@/api/basic/user";
import { DIC } from "@/const/dic";
import VueQr from "vue-qr";
import { exportExcel } from "xlsx-oc";
import { stockFormOption } from "@/const/salesCloud/stockFormOption";
import { getCompany } from "@/util/auth";
import { formatterDateToUTC, parseStatus } from "@/util/util";
import { log } from "util";
import { excelaxios } from "@/util/excelaxios";
export default {
  name: "detail",
  components: {
    VueQr
  },
  data() {
    return {
      tableOption: arDetailOption, //表格设置属性
      table1Option: stockFormOption,
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      detailId: this.$route.params.id,
      eleDialog: false,
      reasonDialog: false,
      lookDialog: false,
      isOpen: false,
      isPrint: false,
      stockData: {},
      table1Data: {},
      returnReason: "",
      serviceCategoryId: "",
      serviceItemId: "",
      payTime: {},
      from: {
        text: "text"
      },
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      users: [],
      userType: "JOINS_ENGINEER",
      point: {},
      serviceCategorys: [],
      serviceCategory: {},
      joinsWorkServiceItems: [],
      workOrderStatus: DIC.WORK_ORDER_STATUS,
      QRCodeDialog: false,
      config: {},
      evaluateDialog: false,
      score: 5,
      clues: [],
      evaluateObj: {},
      serviceItem: {},
      workerUser: {},
      workOrderData: {},
      stockSuperviseDialog: false,
      serviceFee: [],
      propertiesViceList: [],
      value: "",
      downloadData: {}
    };
  },
  created() {
    console.log(this);
    this.handleList();
  },
  watch: {},
  mounted() {
    // this.refreshChange(this.page);
  },
  computed: {},
  props: [],
  methods: {
    handleDetailOut() {
      stockRemoval(this.rowId).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "出库成功",
            type: "success"
          });
          this.handleList();
          this.lookDialog = false;
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    typeEditOk() {
      console.log(this.rowId);
      let params = {
        returnReason: this.returnReason
      };
      if (this.returnReason.replace(/(^\s+)|(^\s+$)/g, "")) {
        stockRemovalReturn(this.rowId, params).then(res => {
          console.log("退回", res);
          this.reasonDialog = true;

          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "退回中...",
              type: "error"
            });
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: "退回成功",
                type: "success"
              });
              this.handleList();
              this.lookDialog = false;
            }, 2000);
            this.reasonDialog = false;
          } else {
            this.$message({
              showClose: true,
              message: "退回中...",
              type: "error"
            });
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
              this.handleList();
            }, 2000);
            this.reasonDialog = false;
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: "请填写拒绝理由",
          type: "error"
        });
      }
    },
    handleDialog(row, index) {
      this.stockSuperviseDialog = true;
      // this.evaluateDialog =true
      this.formobj = row;
      console.log(row, index);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      let id = this.$route.params.id;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      invoiceSystemV2ReceiverAgentDetail(id, params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      let id = this.$route.params.id;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      invoiceSystemV2ReceiverAgentDetail(id, params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchClear() {
      // this.$refs.crud.$refs.searchForm.resetFields();
      console.log(this);
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      // params.number = this.$route.params.number ? this.$route.params.number : ''
      let id = this.$route.params.id;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      } else {
        params.startTime = "";
        params.endTime = "";
      }
      // console.log(this.$refs.crud.resetForm)
      if (this.serviceCategoryId) {
        params.serviceCategoryId = this.serviceCategoryId;
      }
      if (this.serviceItemId) {
        params.serviceItemId = this.serviceItemId;
      }
      this.downloadData = params;
      console.log(params);
      console.log(this);
      invoiceSystemV2ReceiverAgentDetail(id, params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      // let params = {}
      console.log(page);
      let id = this.$route.params.id;
      params.page = page.page.currentPage;
      params.size = page.page.pageSize;
      console.log(params);
      this.downloadData = params;
      invoiceSystemV2ReceiverAgentDetail(id, params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },

    handleDetail() {},
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.point = {};
      this.serviceCategory = {};
      this.joinsWorkServiceItems = [];
      this.$refs.crud.rowAdd();
    },
    handleEdit() {},
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = this.$route.params;
      let id = this.$route.params.id;
      console.log(params);
      console.log(this.$route.params);
      this.downloadData = params;
      invoiceSystemV2ReceiverAgentDetail(id, params).then(res => {
        let data = JSON.parse(res.data);
        console.log(params);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave() {},
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate() {},
    handleFormatterDateToUTC(data) {
      return formatterDateToUTC(data);
    },
    serviceListing(row) {
      this.lookDialog = true;
      console.log(row);
      this.rowId = row.id;
      invoiceSystemV2Purchase(this.rowId).then(res => {
        console.log(res);
        let data = JSON.parse(res.data);
        console.log(this);
        console.log("invoiceSystemV2Purchase", data);
        // data.createTime = this.handleFormatterDateToUTC(data.createTime);
        this.stockData = data;
        this.table1Data = data.goods;
        this.isOpen = true;
        // this.page = {
        //   total: data.total,
        //   currentPage: this.page.currentPage,
        //   pageSize: this.page.pageSize
        // };
        this.tableLoading = false;
      });
      // this.$router.push({
      //   name: "采购出库单",
      //   params: { id: row.purchaseId }
      // });
      console.log(row);
    },
    downloadExcelArDetail() {
      // let params = this.downloadData;
      // let url = `/joins-invoice-system/v1/ar/exportArDetail?`;
      // excelaxios(url, params);
      let params = this.downloadData;
      let id = this.$route.params.id;
      invoiceSystemV2ReceiverAgentDetailDownload(id, params).then(res => {
        window.open(res);
      });
    },
    doPdf() {
      downloadPDF(this.rowId);
      console.log("111");
    },
    doPrint() {
      this.isPrint = true;
      this.companyName = getCompany();
      this.$nextTick(() => {
        var printBox = document.getElementById("printBox");
        //拿到打印的区域的html内容
        var newContent = printBox.innerHTML;
        //将旧的页面储存起来，当打印完成后返给给页面。
        var oldContent = document.body.innerHTML;
        //赋值给body
        document.body.innerHTML = newContent;
        //执行window.print打印功能
        window.print();
        // 重新加载页面，以刷新数据。以防打印完之后，页面不能操作的问题
        document.body.innerHTML = oldContent;
        window.location.reload(false);
        return false;
      });
    },
    printJson() {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      let id = this.$route.params.id;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      }
      invoiceSystemV2ReceiverAgentDetail(id, params).then(res => {
        let data = JSON.parse(res.data);
        let someJSONdata = data.rows;
        someJSONdata = someJSONdata.map(item => {
          this.tableLoading = true;
          item.payTime = item.payTime ? formatterDateToUTC(item.payTime) : "";
          item.purchaseTime = formatterDateToUTC(item.purchaseTime);
          if (item.status == "NO") {
            item.status = "未收款";
          } else if (item.status == "YES") {
            item.status = "已收款";
          } else {
            item.status = "error:" + item.status;
          }
          return item;
        });
        this.tableLoading = false;
        let s = formatterDateToUTC(new Date().getTime());
        let c = getCompany();
        printJS({
          printable: someJSONdata,
          header: `<div style='position:absolute;bottom:0;display:flex;flex-flow: row nowrap;width:100%; justify-content: space-between;'><div>打印时间：${s}</div><div style="margin-right:15px;">${c}</div></div>`,
          properties: [
            { field: "number", displayName: "应收款编号" },
            { field: "businessNumber", displayName: "采购订单编号" },
            { field: "account", displayName: "账号" },
            { field: "shopName", displayName: "店铺名称" },
            { field: "purchaseTime", displayName: "采购时间" },
            { field: "status", displayName: "应收款状态" },
            { field: "payTime", displayName: "支付时间" },
            { field: "money", displayName: "应收款总计金额" }
          ],
          gridHeaderStyle:
            "border: 1px solid  lightgray;white-space:nowrap;padding:0px 8px;text-align:center ",
          gridStyle:
            "border: 1px solid lightgray;white-space:nowrap;padding:8px 10px ;text-align:center",
          type: "json"
        });
      });
    }
  }
};
</script>

    <style scoped lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.stockwrap {
  background: #fff;
  margin: 1px 10px;
  padding-bottom: 100px !important;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stockMain {
  // border: 1px solid #606266;
  display: flex;
  width: 100%;
  flex-flow: column wrap;
  justify-content: center;
  align-items: flex-start;
  margin: 1px 20px;
  font-size: 14px;
  color: #333;
  .content {
    border: none;
    ul {
      .titleLi {
        display: flex;
        justify-content: flex-start;
      }
      .titleLi .d {
        width: 300px;
        span {
          margin-right: 10px;
        }
      }
    }
  }
  .title {
    position: relative;
    left: 50%;
    border: none;
    font-weight: Medium;
    font-size: 22px;
    margin-bottom: 30px;
    color: #333;
    margin-left: -37px;
  }
  .btn {
    position: absolute;
    bottom: 20px;
    left: 0;
    border: none;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    button {
      margin: 0 20px;
    }
  }
}
.avue-crud {
  margin-right: 0;
  margin: 0;
}
</style>
<style lang="scss">
@media print {
  #printTime {
    width: 100%;
    position: absolute;
    bottom: 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }
  #printBox {
    position: relative;
    left: 0;
  }
  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 1px solid #333;
  }
  .el-table--border td,
  .el-table--border th {
    border-right: 1px solid #333;
  }
  .el-table th {
    // border-top: 1px solid #333;
  }
  .el-table--border,
  .el-table--group {
    border: 1px solid #333;
  }
  .el-table--enable-row-transition {
    border: 1px solid #333;
  }

  #printTitle {
    position: relative;
    border: none;
    left: 50%;
    font-weight: Medium;
    font-size: 22px;
    margin-bottom: 30px;
    color: #333;
    margin-left: -37px;
  }
  #noprint {
    display: none;
  }
  .avue-crud {
    margin-right: 0;
    margin: 0;
    width: 900px;
  }
  #content {
    color: #333;
    border: none;
    margin-left: 6%;
    ul {
      .titleLi {
        display: flex;
        justify-content: flex-start;
      }
      .titleLi span {
        margin-left: 10px;
        color: #333;
      }
      .titleLi .d {
        width: 345px;
      }
    }
  }
}
.print {
  display: block;
}
</style>